import axios from 'axios'
import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

// Disparo manual (por tenant) dos jobs @Scheduled. Todos GET fire-and-forget: o backend roda
// async e responde 200 na hora. O X-TENANT-ID vai por-request (a tela de gestão opera sobre um
// único tenant), evitando mutar o header global default do apiService.
const executarJob = async (
  path: string,
  mensagemOk: string,
  tenantId?: string
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.get(
      path,
      tenantId ? { headers: { 'X-TENANT-ID': tenantId } } : undefined
    )
    if (result.status === 200) {
      return { info: mensagemOk }
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getExecutarSnapshot = (tenantId?: string) =>
  executarJob(
    'app/jobs/predicao-snapshot',
    'Snapshot iniciado com sucesso',
    tenantId
  )

export const getExecutarReconciliacao = (tenantId?: string) =>
  executarJob(
    'app/jobs/predicao-reconciliacao',
    'Reconciliação iniciada com sucesso',
    tenantId
  )

export const getExecutarMixRecomendacao = (tenantId?: string) =>
  executarJob(
    'app/jobs/mix-recomendacao',
    'Recálculo do Mix iniciado com sucesso',
    tenantId
  )

export const getExecutarExpurgo = (tenantId?: string) =>
  executarJob(
    'app/jobs/predicao-expurgo',
    'Expurgo iniciado com sucesso',
    tenantId
  )

/**
 * Recálculo da Central de Resultados de UM tenant (PD-0007).
 *
 * ⚠️ Não passa pelo `executarJob` acima e isso é de propósito — três diferenças de contrato:
 * - é **POST em `/central/**`**, não GET em `/app/jobs/*`: o job escreve no banco Master e é rota de
 *   super-admin (`assertSuperAdminHumano`), enquanto `/app/jobs/*` é fail-open para o tenant;
 * - o tenant vai **no path**, não no header `X-TENANT-ID`;
 * - é **síncrono**: o 200 significa "já terminou", não "iniciou". Por isso a mensagem de sucesso fala
 *   em concluído — dizer "iniciado" aqui mandaria o super-admin esperar por algo que já acabou.
 *
 * O **409** é recusa por operação pesada em andamento naquela conta (sync de vendas ou a rodada
 * noturna), vem **sem corpo**, e por isso a mensagem é montada aqui — o `catchError` genérico
 * devolveria "Algo de errado aconteceu!" para uma situação que só pede "tente daqui a pouco".
 */
export const postExecutarCentralResultados = async (
  tenantId?: string
): Promise<{ info: string } | { message: string }> => {
  if (!tenantId) {
    return { message: 'Organização sem tenant identificado.' }
  }
  try {
    const result = await apiService.post(
      `central/resultados/tenant/${tenantId}/recalcular`
    )
    if (result.status === 200) {
      return { info: 'Central de Resultados recalculada com sucesso' }
    }
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 409) {
      return {
        message:
          'Esta conta está com uma operação pesada em andamento (sincronização de vendas ou recálculo). Tente novamente em alguns minutos.',
      }
    }
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}
